<template lang="pug">
#modal-dinamica-laudos
    el-dialog.solicitar(
        :title='$t("mensagens.home.acessoRapido.botoes.SOLICITAR-LAUDO")',
        :visible.sync='showModal',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :before-close='fecharModal',
        :destroy-on-close='true'
    )
        .d-flex.laudo-margin
            SelecionarTipoLaudo(
                :laudoId='laudoId',
                @laudoUnico='atualizaLaudoUnico',
                @nomeComponenteSelecionado='atualizaNomeComponente'
            )
        component(
            :is='modalNome',
            @atualizarTerritoriosSelecionados='atualizarTerritoriosSelecionados',
            @voltar='voltar',
            :showModalOpcoes='showModalOpcoes',
            @showModalOpcoes='fecharModal',
            @showModalCarJaCadastrados='emitShowModalCarJaCadastrado',
            @showModalSelecionarTerritorios='fecharModal',
            @getLaudos='getLaudos'
        )
    el-dialog(
        :title='tituloConfirmarTerritorio',
        :visible.sync='showModalConfirmarTerritorios',
        close='changeShowModalConfirmarTerritorios',
        width='560px'
    )
        ConfirmarTerritorio(
            :selecionados='territoriosSelecionados',
            :tipoLaudo='tipoLaudo',
            @voltar='voltar'
        )
</template>

<script>
import SelecionarTipoLaudo from '@/components/laudos/SelecionarTipoLaudo.vue';
import ConfirmarTerritorio from '@/components/laudos/ConfirmarTerritorio.vue';
import EventBus from '@/utils/eventBus';

import LaudoGeralModal from '@/views/laudos/selecaoVazia/LaudoGeralModal.vue';
import LaudoAvaliacaoFundiariasModal from '@/views/laudos/avaliacaoFundiaria/LaudoAvaliacaoFundiariasModal.vue';
import LaudoAgricolaModal from '@/views/laudos/agricola/LaudoAgricolaModal.vue';
import LaudoBacenFiscalizacaoModal from '@/views/laudos/bacenFiscalizacao/LaudoBacenFiscalizacaoModal.vue';
import LaudoBenfeitoriasModal from '@/views/laudos/benfeitorias/LaudoBenfeitoriasModal.vue';
import LaudoConformidadeAmbientalModal from '@/views/laudos/conformidadeAmbiental/LaudoConformidadeAmbientalModal.vue';
import LaudoCarbonoModal from '@/views/laudos/carbono/LaudoCarbonoModal.vue';
import LaudoHistoricoAgricolaModal from '@/views/laudos/historicoAgricola/LaudoHistoricoAgricolaModal.vue';
import LaudoDiagnosticoAgricolaModal from '@/views/laudos/diagnosticoAgricola/LaudoDiagnosticoAgricolaModal.vue';
import LaudoSupressaoVegetalModal from '@/views/laudos/supressaoVegetal/LaudoSupressaoVegetalModal.vue';
import LaudoTecnicoAgricolaModal from '@/views/laudos/tecnicoAgricola/LaudoTecnicoAgricolaModal.vue';
import LaudoCroquiModal from '@/views/laudos/croqui/LaudoCroquiModal.vue';
import LaudoBacenResolucao140Modal from '@/views/laudos/bacenResolucao140/LaudoBacenResolucaoModal.vue';
import LaudoAvaliacaoAreaProdutivaModal from '@/views/laudos/avaliacaoAreaProdutiva/LaudoAvaliacaoAreaProdutivaModal.vue';
import LaudoAvaliacaoSocioambientalModal from '@/views/laudos/avaliacaoSocioambiental/LaudoAvaliacaoSocioambientalModal.vue';
import LaudoRenovabioModal from '@/views/laudos/renovabio/LaudoRenovabioModal.vue';
import TipoLaudo from '@/constants/TipoLaudo';

export default {
    name: 'ModalTipoLaudo',
    components: {
        SelecionarTipoLaudo,
        ConfirmarTerritorio,
        LaudoGeralModal,
        LaudoAvaliacaoFundiariasModal,
        LaudoAgricolaModal,
        LaudoBacenFiscalizacaoModal,
        LaudoBenfeitoriasModal,
        LaudoConformidadeAmbientalModal,
        LaudoCarbonoModal,
        LaudoHistoricoAgricolaModal,
        LaudoDiagnosticoAgricolaModal,
        LaudoSupressaoVegetalModal,
        LaudoTecnicoAgricolaModal,
        LaudoCroquiModal,
        LaudoBacenResolucao140Modal,
        LaudoAvaliacaoAreaProdutivaModal,
        LaudoAvaliacaoSocioambientalModal,
        LaudoRenovabioModal
    },
    props: {
        showModalSelecionarTerritorios: {
            type: Boolean,
            default: false
        },
        showModalOpcoes: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        showModalOpcoes(newValue) {
            if (newValue) {
                this.showModal = newValue;
            }
        },
        showModalSelecionarTerritorios(newValue) {
            if (newValue) {
                this.showModal = newValue;
                this.laudoId = this.laudoJaSelecionado;
            } else if (!newValue && !this.showModalConfirmarTerritorios) {
                this.laudoId = this.laudoJaSelecionado;
                this.showModalSelecionarTerritorios = false;
            }
        },
        showModalConfirmarTerritorios(newValue) {
            if (!newValue) {
                if (this.laudoJaSelecionado !== this.laudoId) {
                    this.laudoId = this.laudoJaSelecionado;
                    this.showModal = false;
                }
            }
        }
    },
    data() {
        return {
            modalNome: 'LaudoGeralModal',
            tipoLaudo: null,
            isLaudoUnico: false,
            laudoId: null,
            laudoJaSelecionado: null,
            tituloConfirmarTerritorio: null,
            showModalConfirmarTerritorios: false,
            territoriosSelecionados: [],
            showModal: this.showModalSelecionarTerritorios
        };
    },
    created() {
        EventBus.$off('laudo-selecionado');
        EventBus.$on('laudo-selecionado', laudoId => {
            if (this.laudoJaSelecionado === null) {
                this.laudoJaSelecionado = laudoId;
            }
            this.laudoId = laudoId;
        });
    },
    methods: {
        emitShowModalCarJaCadastrado(
            quantidadeCARs,
            laudosInfo,
            carsJaCadastrados
        ) {
            this.fecharModal();
            this.$emit(
                'showModalCarsJaEncontrados',
                quantidadeCARs,
                laudosInfo,
                carsJaCadastrados
            );
        },
        fecharModal() {
            this.showModal = false;
            this.$emit('setarFecharModalTipoLaudo');
        },
        changeShowModalConfirmarTerritorios() {
            this.showModalConfirmarTerritorios =
                !this.showModalConfirmarTerritorios;
            this.$emit('setarFecharModalTipoLaudo');
        },
        voltar() {
            this.changeShowModalConfirmarTerritorios();
        },
        atualizaLaudoUnico(laudoUnico) {
            this.isLaudoUnico = laudoUnico === 'true';
        },
        atualizaNomeComponente(nomeComponente) {
            this.modalNome = nomeComponente;
            switch (this.modalNome) {
                case 'LaudoGeralModal':
                    this.tipoLaudo = null;
                    break;
                case 'LaudoAgricolaModal':
                    this.tipoLaudo = TipoLaudo.AGRICOLA;
                    this.tituloConfirmarTerritorio = this.$t(
                        'mensagens.laudos.solicitacaoDeLaudoAgricola'
                    );
                    break;
                case 'LaudoAvaliacaoAreaProdutivaModal':
                    this.tipoLaudo = TipoLaudo.AVALIACAO_DE_AREA_PRODUTIVA;
                    this.tituloConfirmarTerritorio = this.$t(
                        'mensagens.laudos.solicitacaoDeLaudoAvaliacaoAreaProdutiva'
                    );
                    break;
                case 'LaudoAvaliacaoFundiariasModal':
                    this.tipoLaudo = TipoLaudo.AVALIACAO_FUNDIARIA;
                    break;
                case 'LaudoAvaliacaoSocioambientalModal':
                    this.tipoLaudo = TipoLaudo.AVALIACAO_SOCIOAMBIENTAL;
                    this.tituloConfirmarTerritorio = this.$t(
                        'mensagens.laudos.solicitacaoDeLaudoDeAvaliacaoSocioambiental'
                    );
                    break;
                case 'LaudoBacenFiscalizacaoModal':
                    this.tipoLaudo = TipoLaudo.BACEN_FISCALIZACAO;
                    break;
                case 'LaudoBacenResolucao140Modal':
                    this.tipoLaudo = TipoLaudo.BACEN_140;
                    break;
                case 'LaudoBenfeitoriasModal':
                    this.tipoLaudo = TipoLaudo.BENFEITORIAS;
                    break;
                case 'LaudoCarbonoModal':
                    this.tipoLaudo = TipoLaudo.CARBONO;
                    this.tituloConfirmarTerritorio = this.$t(
                        'mensagens.laudos.solicitacaoDeLaudoCarbono'
                    );
                    break;
                case 'LaudoConformidadeAmbientalModal':
                    this.tipoLaudo = TipoLaudo.CONFORMIDADE;
                    break;
                case 'LaudoCroquiModal':
                    this.tipoLaudo = TipoLaudo.CROQUI;
                    break;
                case 'LaudoDiagnosticoAgricolaModal':
                    this.tipoLaudo = TipoLaudo.DIAGNOSTICO_AGRICOLA;
                    this.tituloConfirmarTerritorio = this.$t(
                        'mensagens.laudos.solicitacaoDeLaudoDiagnosticoAgricola'
                    );
                    break;
                case 'LaudoHistoricoAgricolaModal':
                    this.tipoLaudo = TipoLaudo.HISTORICO_AGRICOLA;
                    this.tituloConfirmarTerritorio = this.$t(
                        'mensagens.laudos.solicitacaoDeLaudoHistoricoAgricola'
                    );
                    break;
                case 'LaudoRenovabioModal':
                    this.tipoLaudo = TipoLaudo.RENOVABIO;
                    break;
                case 'LaudoSupressaoVegetalModal':
                    this.tipoLaudo = TipoLaudo.SUPRESSAO_VEGETAL;
                    this.tituloConfirmarTerritorio = this.$t(
                        'mensagens.laudos.solicitacaoDeLaudoSupressaoVegetal'
                    );
                    break;
                case 'LaudoTecnicoAgricolaModal':
                    this.tipoLaudo = TipoLaudo.TECNICO_AGRICOLA;
                    break;
            }
        },
        atualizarTerritoriosSelecionados(territoriosSelecionados) {
            this.territoriosSelecionados = territoriosSelecionados;
            this.changeShowModalConfirmarTerritorios();
            this.$emit('atualizarTerritoriosSelecionados');
        },
        async getLaudos() {
            this.$emit('getLaudos');
        }
    }
};
</script>

<style lang="scss">
#modal-dinamica-laudos {
    div.el-dialog__wrapper.solicitar div div.el-dialog__header {
        padding-bottom: 10px !important;
        background-color: var(--default-background-color);
        .el-dialog__title {
            font-weight: 600;
            color: var(--primary);
        }
    }
    .laudo-margin {
        margin-bottom: 10px;
    }
}
</style>
